/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_reinsurances_safe_payment_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `Nakupujte na našem webu se sebevědomím`
};

const da_reinsurances_safe_payment_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `Køb trygt på vores side`
};

const de_reinsurances_safe_payment_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `Kaufen Sie sicher auf unserer Website ein`
};

const en_reinsurances_safe_payment_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `Buy on our website with confidence`
};

const es_reinsurances_safe_payment_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `Compra en nuestro sitio con total confianza`
};

const fr_reinsurances_safe_payment_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `Achetez sur notre site en tout confiance`
};

const hu_reinsurances_safe_payment_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `Vásárolj bizalommal az oldalalunk`
};

const it_reinsurances_safe_payment_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `Acquista sul nostro sito in tutta sicurezza`
};

const nl_reinsurances_safe_payment_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `Koop met vertrouwen op onze site`
};

const pl_reinsurances_safe_payment_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `Kupuj u nas bez obaw`
};

const pt_reinsurances_safe_payment_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `Compre em nosso site com total confiança`
};

const sv_reinsurances_safe_payment_subtext = /** @type {(inputs: {}) => string} */ () => {
	return `Handla tryggt på vår sida`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const reinsurances_safe_payment_subtext = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.reinsurances_safe_payment_subtext(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("reinsurances_safe_payment_subtext", locale)
	if (locale === "cs") return cs_reinsurances_safe_payment_subtext(inputs)
	if (locale === "da") return da_reinsurances_safe_payment_subtext(inputs)
	if (locale === "de") return de_reinsurances_safe_payment_subtext(inputs)
	if (locale === "en") return en_reinsurances_safe_payment_subtext(inputs)
	if (locale === "es") return es_reinsurances_safe_payment_subtext(inputs)
	if (locale === "fr") return fr_reinsurances_safe_payment_subtext(inputs)
	if (locale === "hu") return hu_reinsurances_safe_payment_subtext(inputs)
	if (locale === "it") return it_reinsurances_safe_payment_subtext(inputs)
	if (locale === "nl") return nl_reinsurances_safe_payment_subtext(inputs)
	if (locale === "pl") return pl_reinsurances_safe_payment_subtext(inputs)
	if (locale === "pt") return pt_reinsurances_safe_payment_subtext(inputs)
	return sv_reinsurances_safe_payment_subtext(inputs)
};
export { reinsurances_safe_payment_subtext as "reinsurances.safe_payment_subtext" }